import React from 'react';
// import Nav from 'react-bootstrap/Nav';
// import { Link } from 'react-router-dom';

const Ribbon = () => {

    let host = window.location.hostname;

    let hostURL = host === "localhost" ? "sfworks.xyz" : formatHost(host);

    return (
        <div className="ribbon text-center" style={{ padding: ".5rem 1rem" }}>

            <a href={"//scavengerhunt." + hostURL + "/"} target="_blank">
                <span className="d-none d-lg-inline">Scavenger Hunt: Track Down the Clues for a Chance to</span> Win a $100 Sentai Gift Card.
            </a>

        </div>
    );
}

function formatHost(host) {

    let arr = host.split(".");
    arr.shift();
    let newHost = arr.join(".");

    return newHost;
}

export default Ribbon;
